import { useEffect, useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import { useNavigate } from "react-router-dom";
import baseURL from "../../../../configs/api";
import axios from 'axios';
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Select, { components } from "react-select";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import { iconValues } from "../../../../utils/iconValues";
import React from "react";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";
import AvailabilityInput from "../../../../components/AvailabilityInput";


export const AddAdditionalCharges = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const [name, setName] = useState<string>("");
  const [categories, setCategories] = useState([]);
  const [addOnCategoryId, setAddOnCategoryId] = useState<string>("");
  const [selectionType, setSelectionType] = useState<string>("Only One");
  const [chargeType, setChargeType] = useState<string>("Percent");
  const [
    decreasingRateBasedonIntervalPerDay,
    setDecreasingRateBasedonIntervalPerDay,
  ] = useState<string>("No");
  const [
    decreasingRateBasedonIntervalPerHour,
    setDecreasingRateBasedonIntervalPerHour,
  ] = useState<string>("No");
  const [
    decreasingRateBasedonIntervalPerMonth,
    setDecreasingRateBasedonIntervalPerMonth,
  ] = useState<string>("No");
  const [
    decreasingRateBasedonIntervalPerMinute,
    setDecreasingRateBasedonIntervalPerMinute,
  ] = useState<string>("No");
  const [
    decreasingRateBasedonIntervalPerWeek,
    setDecreasingRateBasedonIntervalPerWeek,
  ] = useState<string>("No");
  const [showOnWebsite, setShowOnWebsite] = useState<string>("No");
  const [includeInTax, setIncludeInTax] = useState<string>("No");
  const [hideFromReservations, setHideFromReservations] = useState<string>("No");
  const [includeInLocationFee, setIncludeInLocationFee] = useState<string>("No");
  const [isAdditionalChargesOverview, setIsAdditionalChargesOverview] = useState<boolean>(true);
  const [isDefaultSettings, setIsDefaultSettings] = useState<boolean>(true);
  const [isDayRules, setIsDayRules] = useState<boolean>(false);
  const [isAdvanced, setIsAdvanced] = useState<boolean>(true);
  const [isWebsite, setIsWebsite] = useState<boolean>(true);
  const [menuBarIcon, setMenuBarIcon] = useState<any>();
  const [menuTopBarIcon, setMenuTopBarIcon] = useState<string>("");
  const [branches, setBranches] = useState<any[]>([]);
  const [isChange, setIsChange] = useState<boolean>(false);
  const [statementForAggrement, setStatementForAggrement] = useState<string>("");
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [vehicleClasses, setVehicleClasses] = useState<any>();
  const [vehicleClassOptions, setVehicleClassOptions] = useState<any[]>([]);
  const [isNameAvailable, setIsNameAvailable] = useState<boolean>(true);

  useEffect(() => {
    axios
      .get(`${baseURL}addOnCategory`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setCategories(() =>
          response.data.map((item: any) => {
            return { value: item.id, label: item.name };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axios
      .get(`${baseURL}branch`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setBranches(() =>
          response.data.map((item: any) => {
            return {
              branchId: item.id,
              branchName: item.branchName,
              anountOrPercentage: "0",
              mandatory: false,
              mandatoryOnPublicReservations: false,
              mandatoryOnInternalReservations: false,
              isActive: true,
            };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axios
      .get(`${baseURL}vehicleClass`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setVehicleClassOptions(() =>
          response.data.map((item: any) => {
            return {
              value: item.id,
              label: item.name
            };
          })
        );

        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);





  const Option = (props: any) => (
    <components.Option {...props} className="top-bar-icon-option">
      <div className="flex item-center gap-x-[0.25rem] my-auto">
        {props?.data?.icon && (
          <span className={`material-symbols-outlined text-[16px] mr-[3px] font-normal ${themeStyles.form.tailwindInputTextColor} cursor-pointer`}>{props.data.icon}</span>
        )}
        {props.data.label}
      </div>
    </components.Option>
  );

  const handleMenuChange = (value: any) => {
    setMenuBarIcon(value);
    setMenuTopBarIcon(value.value);
  };

  const SingleValue = ({ children, ...props }: any) => (
    <components.SingleValue {...props}>
      <div className="flex item-center gap-x-[0.25rem] my-auto">
        {menuBarIcon?.icon && (
          <span className={`material-symbols-outlined text-[16px] mr-[3px] font-normal ${themeStyles.form.tailwindInputTextColor} cursor-pointer`}>{menuBarIcon?.icon}</span>
        )}
        {children}
      </div>
    </components.SingleValue>
  );

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    if (isNameAvailable) {
      setPleaseWaitPopup(true);
      e.preventDefault();

      await axios
        .post(
          `${baseURL}additionalCharge?userId=${auth?.id}`,
          JSON.stringify({
            name,
            addOnCategoryId,
            selectionType,
            chargeType,
            icon: menuTopBarIcon,
            decreasingRateBasedonIntervalPerDay: decreasingRateBasedonIntervalPerDay === "Yes" ? true : false,
            decreasingRateBasedonIntervalPerHour: decreasingRateBasedonIntervalPerHour === "Yes" ? true : false,
            decreasingRateBasedonIntervalPerMonth: decreasingRateBasedonIntervalPerMonth === "Yes" ? true : false,
            decreasingRateBasedonIntervalPerMinute: decreasingRateBasedonIntervalPerMinute === "Yes" ? true : false,
            decreasingRateBasedonIntervalPerWeek: decreasingRateBasedonIntervalPerWeek === "Yes" ? true : false,
            showOnWebsite: showOnWebsite === "Yes" ? true : false,
            includeInTax: includeInTax === "Yes" ? true : false,
            hideFromReservations: hideFromReservations === "Yes" ? true : false,
            includeInLocationFee: includeInLocationFee === "Yes" ? true : false,
            statementForAggrement,
            additionalChargeByBranches: branches,
            vehicleClassAdditionalCharges: vehicleClasses?.map((item: any) => ({ vehicleClassId: item?.value }))
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          navigate(-1);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    }
  };

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>

              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Additional Charge</h2>
                </div>
              </div>

              <div className="mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="w-full px-2">
                    <h5 className="pb-0 mt-2 mb-0 flex justify-start items-center cursor-pointer"
                      onClick={() => setIsAdditionalChargesOverview(!isAdditionalChargesOverview)}
                    >
                      {isAdditionalChargesOverview ? (
                        <ExpandMoreIcon sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRightIcon sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}{" "}
                      <div style={{ color: themeStyles.topBar.textColor }}>Additional Charge Overview</div>
                    </h5>
                    <hr className="mb-2" />
                    {isAdditionalChargesOverview && (

                      <div className="grid grid-cols-3 gap-6">
                        <div className="space-y-4">
                          <AvailabilityInput
                            label="Name"
                            name="name"
                            value={name}
                            onChange={setName}
                            baseURL={baseURL}
                            onAvailabilityChange={setIsNameAvailable}
                          />

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Selection Type{" "}
                              <div className="group relative inline-block">
                                <HelpOutlineOutlinedIcon sx={{ fontSize: "16px", cursor: "pointer" }} />

                                <span className={"absolute z-10 w-[150px] text-[10px] bg-white text-gray-600 text-center py-[5px] rounded border border-gray-400 bottom-full left-1/2 -ml-[75px] invisible group-hover:visible"}>
                                  <span
                                    className="absolute top-full left-[51%] -ml-[8px] border-8 border-transparent border-t-white z-10"
                                  />
                                  <span
                                    className="absolute top-full left-1/2 -ml-[8px] border-10 border-transparent border-t-gray-400"
                                  />
                                  "Only one" will charge amount as one time but "Multiple" will charge the amount per day
                                </span>
                              </div>
                            </label>
                            <select
                              className={`w-full px-[8px] py-[10px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={selectionType}
                              onChange={(e) => setSelectionType(e.target.value)}
                            >
                              <option value="Only One">Only One</option>
                              <option value="Multiple">Multiple</option>
                            </select>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Icon</label>
                            <Select
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                  borderRadius: '8px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                  "&: hover": {
                                    borderColor: "#167AC3",
                                  }

                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                }),
                                option: (base, state) => {
                                  const isSelected = state.isSelected;
                                  const isFocused = state.isFocused;
                                  const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                  const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                  const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                  return {
                                    ...base,
                                    backgroundColor: isSelected
                                      ? selectedBg
                                      : isFocused
                                        ? hoverBg
                                        : "transparent",
                                    color: isSelected ? "#fff" : defaultTextColor,
                                    fontWeight: 600,
                                    ':active': {
                                      backgroundColor: isSelected ? selectedBg : hoverBg,
                                    },
                                  };
                                },
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,
                                }),
                              }}
                              components={{
                                Option,
                                SingleValue,
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={false}
                              isLoading={false}
                              isClearable={true}
                              isRtl={false}
                              isSearchable={false}
                              name="menu"
                              value={menuBarIcon}
                              options={iconValues}
                              onChange={handleMenuChange}
                              required
                            />
                          </div>

                          <div className="mt-6">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Decreasing Rate Based on Interval (Per Day)</label>
                            <RadioGroup
                              row
                              value={decreasingRateBasedonIntervalPerDay}
                              onChange={(e) => setDecreasingRateBasedonIntervalPerDay(e.target.value)}
                            >
                              <FormControlLabel

                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div className="mt-6">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Decreasing Rate Based on Interval (Per Hour)</label>
                            <RadioGroup
                              row
                              value={decreasingRateBasedonIntervalPerHour}
                              onChange={(e) => setDecreasingRateBasedonIntervalPerHour(e.target.value)}
                            >
                              <FormControlLabel

                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div className="mt-6">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Decreasing Rate Based on Interval (Per Month)</label>
                            <RadioGroup
                              row
                              value={decreasingRateBasedonIntervalPerMonth}
                              onChange={(e) => setDecreasingRateBasedonIntervalPerMonth(e.target.value)}
                            >
                              <FormControlLabel

                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>

                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Category</label>
                            <select
                              className={`w-full px-[8px] py-[10px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={addOnCategoryId}
                              onChange={(e) => setAddOnCategoryId(e.target.value)}
                              required
                            >
                              <option style={{ color: "gray" }} value={""}>
                                Select...
                              </option>
                              {categories.map((item: any) => {
                                return <option value={item.value}>{item.label}</option>;
                              })}
                            </select>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                              Charge Type
                            </label>
                            <select
                              className={`w-full px-[8px] py-[10px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={chargeType}
                              onChange={(e) => setChargeType(e.target.value)}
                            >
                              <option value="Percent">Percent</option>
                              <option value="Amount">Amount</option>
                            </select>
                          </div>

                          <div>
                            <label className={`text-xs font-medium invisible ${themeStyles.form.tailwindLabelTextColor}`}>Name</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md invisible ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            />
                          </div>

                          <div className="mt-6">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Decreasing Rate Based on Interval (Per Minute)</label>
                            <RadioGroup
                              row
                              value={decreasingRateBasedonIntervalPerMinute}
                              onChange={(e) => setDecreasingRateBasedonIntervalPerMinute(e.target.value)}
                            >
                              <FormControlLabel

                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div className="mt-6">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Decreasing Rate Based on Interval (Per Week)</label>
                            <RadioGroup
                              row
                              value={decreasingRateBasedonIntervalPerWeek}
                              onChange={(e) => setDecreasingRateBasedonIntervalPerWeek(e.target.value)}
                            >
                              <FormControlLabel

                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>
                      </div>


                    )}

                    <div className="flex flex-row mt-5 gap-2 text-[12px] text-gray-500">
                      <div className="w-[25%] text-left">Branch</div>
                      <div className="w-[25%] text-left">Amount or %</div>
                      <div className="w-[10%] text-left">Mandatory</div>
                      <div className="w-[14%] text-left">Mandatory on Public Reservations</div>
                      <div className="w-[14%] text-left">Mandatory on Internal Reservations</div>
                      <div className="w-[10%] text-left">Excluded Branches</div>
                    </div>

                    <hr className="mb-0" />

                    {branches.map((item: any, index: number) => (
                      <React.Fragment key={item.id}>
                        <div className="flex flex-row gap-2 text-[12px] text-gray-500">
                          <div className="w-[25%] my-1 text-left">{item.branchName}</div>

                          <hr className="my-0" />

                          <div className="w-[25%] my-1 text-left">
                            <input
                              type="text"
                              placeholder="Enter amount or %"
                              value={item.anountOrPercentage}
                              onChange={(e) => {
                                branches[index].anountOrPercentage = e.target.value;
                                setBranches(branches);
                                setIsChange(!isChange);
                              }}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            />
                          </div>


                          <hr className="my-0" />

                          <div className="w-[10%] my-1 text-left">
                            <input
                              type="checkbox"
                              checked={item.mandatory}
                              onChange={() => {
                                branches[index].mandatory = !item.mandatory;
                                setBranches(branches);
                                setIsChange(!isChange);
                              }}
                            />
                          </div>

                          <hr className="my-0" />

                          <div className="w-[14%] my-1 text-left">
                            <input
                              type="checkbox"
                              checked={item.mandatoryOnPublicReservations}
                              onChange={() => {
                                branches[index].mandatoryOnPublicReservations = !item.mandatoryOnPublicReservations;
                                setBranches(branches);
                                setIsChange(!isChange);
                              }}
                            />
                          </div>

                          <hr className="my-0" />

                          <div className="w-[14%] my-1 text-left">
                            <input
                              type="checkbox"
                              checked={item.mandatoryOnInternalReservations}
                              onChange={() => {
                                branches[index].mandatoryOnInternalReservations = !item.mandatoryOnInternalReservations;
                                setBranches(branches);
                                setIsChange(!isChange);
                              }}
                            />
                          </div>

                          <hr className="my-0" />

                          <div className="w-[10%] my-1 text-left">
                            <input type="checkbox" />
                          </div>
                        </div>

                        <hr className="my-0" />
                      </React.Fragment>
                    ))}


                    <h5 className="pb-0 mt-4 mb-0 flex justify-start items-center cursor-pointer"
                      onClick={() => setIsDefaultSettings(!isDefaultSettings)}
                    >
                      {isDefaultSettings ? (
                        <ExpandMoreIcon sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRightIcon sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}{" "}
                      <div style={{ color: themeStyles.topBar.textColor }}>Default Settings</div>
                    </h5>
                    <hr />
                    {isDefaultSettings && (
                      <div className="grid grid-cols-3 gap-6">
                        <div className="space-y-4">

                          <div className="mt-6">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Include in Tax</label>
                            <RadioGroup
                              row
                              value={includeInTax}
                              onChange={(e) => setIncludeInTax(e.target.value)}
                            >
                              <FormControlLabel

                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div className="mt-6">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Hide From Reservations</label>
                            <RadioGroup
                              row
                              value={hideFromReservations}
                              onChange={(e) => setHideFromReservations(e.target.value)}
                            >
                              <FormControlLabel

                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                              Statement For Agreement
                            </label>
                            <textarea
                              name="statementForAggrement"
                              rows={8}
                              className={`w-full px-[8px] py-[8px] border rounded-md resize-y ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={statementForAggrement}
                              onChange={(e) => setStatementForAggrement(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div className="mt-6">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Include in Location Tax</label>
                            <RadioGroup
                              row
                              value={includeInLocationFee}
                              onChange={(e) => setIncludeInLocationFee(e.target.value)}
                            >
                              <FormControlLabel

                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>
                      </div>
                    )}

                    <h5 className="pb-0 mt-4 mb-0 flex justify-start items-center cursor-pointer"
                      onClick={() => setIsDayRules(!isDayRules)}
                    >
                      {isDayRules ? (
                        <ExpandMoreIcon sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRightIcon sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}{" "}
                      <div style={{ color: themeStyles.topBar.textColor }}>Day Rules</div>
                    </h5>
                    <hr />
                    {isDayRules && (
                      <div style={{ color: themeStyles.topBar.textColor }}>Day Rules</div>
                    )}

                    <h5 className="pb-0 mt-4 mb-0 flex justify-start items-center cursor-pointer"
                      onClick={() => setIsAdvanced(!isAdvanced)}
                    >
                      {isAdvanced ? (
                        <ExpandMoreIcon sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRightIcon sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}{" "}
                      <div style={{ color: themeStyles.topBar.textColor }}>Advanced</div>
                    </h5>
                    <hr />
                    {isAdvanced && (
                      <div className="grid grid-cols-3 gap-6 mt-6">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Show Only in Specific Vehicle Classes</label>
                            <Select
                              menuPortalTarget={document.body}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                  borderRadius: '8px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                  "&: hover": {
                                    borderColor: "#167AC3",
                                  }

                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999
                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                }),
                                option: (base, state) => {
                                  const isSelected = state.isSelected;
                                  const isFocused = state.isFocused;
                                  const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                  const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                  const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                  return {
                                    ...base,
                                    backgroundColor: isSelected
                                      ? selectedBg
                                      : isFocused
                                        ? hoverBg
                                        : "transparent",
                                    color: isSelected ? "#fff" : defaultTextColor,
                                    fontWeight: 600,
                                    ':active': {
                                      backgroundColor: isSelected ? selectedBg : hoverBg,
                                    },
                                  };
                                },
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,
                                }),
                              }}
                              isMulti
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={false}
                              isLoading={false}
                              isClearable={true}
                              isRtl={false}
                              isSearchable={false}
                              name="vehicleClasses"
                              value={vehicleClasses}
                              onChange={setVehicleClasses}
                              options={vehicleClassOptions}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    <h5 className="pb-0 mt-4 mb-0 flex justify-start items-center cursor-pointer"
                      onClick={() => setIsWebsite(!isWebsite)}
                    >
                      {isWebsite ? (
                        <ExpandMoreIcon sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRightIcon sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}{" "}
                      <div style={{ color: themeStyles.topBar.textColor }}>Website</div>
                    </h5>
                    <hr />
                    {isWebsite && (
                      <div className="grid grid-cols-3 gap-6">
                        <div className="space-y-4">
                          <div className="mt-6">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Show on Website?</label>
                            <RadioGroup
                              row
                              value={showOnWebsite}
                              onChange={(e) => setShowOnWebsite(e.target.value)}
                            >
                              <FormControlLabel

                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="flex gap-4 mt-6">
                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.main.bg
                        }}
                        type="submit">
                        Save
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}>
                        Cancel
                      </Button>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}
